module.exports = __webpack_public_path__ + "media/roll.629e2c38.mp3";